<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted } from "vue";

import { useAuthStore } from "@/stores/authStore.ts";
import ModalRenderer from "@/components/ui/ModalRenderer.vue";
import SnackbarComponent from "@/components/ui/SnackbarComponent.vue";
import PublicLayout from "@/layouts/PublicLayout.vue";

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

const layout = computed(() => route.meta.layout || "div");

onMounted(async () => {
  await router.isReady();
  if (authStore.auth.loggedIn && route.meta.layout !== PublicLayout) {
    try {
      await authStore.me();
    } catch {
      /* The API interceptor reports session errors. */
    }
  }
});
</script>

<template>
  <component :is="layout">
    <RouterView />
    <ModalRenderer />
  </component>
  <SnackbarComponent />
</template>
